<template>
    <a-modal :title="$t('hotel.ticket_parameters_configuration' /* 票通参数配置 */)" :visible="visible" :width="800" @ok="handleOk" @cancel="handleCancel">
        <a-form :form="form">
            <a-form-item :label="$t('hotel.child_extension_number' /* 分机号 */)">
                <a-input v-decorator="['extension_num']" :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('hotel.child_extension_number' /* 分机号 */)" />
            </a-form-item>
            <a-form-item :label="$t('hotel.is_open_full_electric_ticket' /* 是否开启全电票 */)">
                <a-radio-group v-decorator="['is_electric', { initialValue: '1' }]">
                    <a-radio value="1">{{ $t('formConfig.yes' /* 是 */) }}</a-radio>
                    <a-radio value="0">{{ $t('formConfig.no' /* 否 */) }}</a-radio>
                </a-radio-group>
                <div class="error-color">
                    {{ $t('hotel.tips' /* 注意：请确定是否已经开通全电发票，如未开通请选择否。 */) }}
                </div>
            </a-form-item>
        </a-form>
    </a-modal>
</template>
  
  <script>
import pick from 'lodash.pick';
const fields = ['extension_num', 'is_electric'];
export default {
    name: 'apiConfig',
    data() {
        return {
            fields,
            form: this.$form.createForm(this),
            recode: {},
            visible: false
        };
    },

    methods: {
        getDetail(recode) {
            this.visible = true;
            this.recode = recode;
            this.$request
                .get({
                    url: 'getModeDetail',
                    data: { channel_id: recode.channel_id, mode_id: recode.id }
                })
                .then(res => {
                    this.form.setFieldsValue(pick(res.data, fields));
                });
        },

        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    let data = {
                        ...values,
                        channel_id: this.recode.channel_id,
                        mode_id: this.recode.id
                    };
                    this.$request.post({ url: 'editMode', data }).then(res => {
                        this.form.resetFields();
                        this.$emit('ok');
                        this.handleCancel();
                    });
                }
            });
        },
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        }
    },
    created() {
        fields.forEach(v => this.form.getFieldDecorator(v));
    }
};
</script>
  
  <style scoped lang="less">
</style>